import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { AuthContext } from "../../providers/AuthProvider";
// import { useFetchWithAuth } from "../../http/FetchWithAuth";
import { authBus } from "../utils/authBus";
import { saveCsrfToken, deleteCsrfToken } from "../../../utils/storage/csrf";
import {
  ResponseError,
  usePublicFetch,
  useAuthorizedFetch,
} from "../../../http";
import { useRouteError } from "../../../errors/ErrorRouteContext";

const API = "https://pwa-server.test/api/v1/auth";

/**
 * User Registration
 *
 * @param {string} name
 * @param {string} email
 * @param {string} fax
 * @param {string} password
 * @returns {string} json {"success": true, "message": "User Created.", "data": []]}
 */
export function useUserRegister() {
  const publicFetch = usePublicFetch();

  const register = useCallback(
    async ({ name, fax, email, password }) => {
      const result = await publicFetch(`${API}/register`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        timeout: 8000,
        body: JSON.stringify({ name, fax, email, password }),
      });
      // console.dir(result);
      // const data = await response.json().catch(() => null);

      if (!result.success) {
        throw new Error(
          result?.message || fax !== "" ? "" : "Registration failed"
        ); // (${result.status})`);
      }

      return result; //data;
      /*
      // response = await publicFetch("/register", {
      //   method: "POST",
      //   retryOnFail: false,
      // });

      // // Robust body parsing (handles 204/empty or text bodies)
      // let data = null;
      // const ct = response.headers.get("content-type") || "";
      // if (ct.includes("application/json")) {
      //   try {
      //     data = await response.json();
      //   } catch {}
      // } else {
      //   try {
      //     data = await response.text();
      //   } catch {}
      // }

      // if (!response.ok) {
      //   const msg = typeof data === "string" ? data : data?.message;
      //   throw new Error(msg || `Logout failed (${response.status})`);
      // }

      // // Clear client auth state
      // // setIsLoggedIn(false);
      // authBus.emit({ type: "unauthenticated" });
      // deleteCsrfToken();

      // if (redirectTo) {
      //   navigate(redirectTo, { replace: true });
      // }

      // return { success: true, data };
      // }, [publicFetch]);
      */
    },
    [publicFetch]
  );
  return { register };
  /*
  // try {
  //   const response = await fetch(
  //     "https://pwa-server.test/api/v1/auth/register",
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ name, email, password }),
  //     }
  //   );

  //   // if (!response.ok) {
  //   //   const errorData = await response.json();
  //   //   // throw new Error(errorData.message || "Registration failed");
  //   // }
  //   return response.json();
  // } catch {
  //   return response.json();
  // }
  */
}

/**
 * User Login Hook: returns a login function that updates AuthContext on success.
 *
 * @param {string} email
 * @param {string} password
 * @returns {string} json {"success": true, "message": "Login Successful.", "data": []]}
 */
function extractCsrf(data) {
  // supports either {csrf_token} or {data:{csrf_token}}
  return data?.data?.csrf_token ?? data?.csrf_token ?? null;
}

/**
 * Login: emits auth events, stores CSRF on success, returns {status, data}.
 * Throws ResponseError on any failure so UI catch can show server messages.
 */
export function useUserLogin() {
  const publicFetch = usePublicFetch();

  return useCallback(
    async ({ email, password }) => {
      try {
        // publicFetch resolves only for 2xx; otherwise it throws ResponseError
        const { status, data } = await publicFetch(`${API}/login`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ email, password }),
        });

        // Some APIs might return 200 with { success:false } — treat as a logical failure.
        if (data?.success === false) {
          authBus.emit({ type: "unauthenticated" });
          throw new ResponseError(data?.message || "Login failed", {
            status,
            data,
          });
        }

        // Success path
        const csrf = extractCsrf(data);
        if (csrf) saveCsrfToken(csrf);

        authBus.emit({ type: "authenticated" });
        return { status, data };
      } catch (e) {
        // Side-effects for known auth failures, then rethrow so UI catch runs.
        if (e instanceof ResponseError) {
          // Emit unauthenticated for auth-related failures
          if ([401, 403, 409, 422].includes(e.status)) {
            authBus.emit({ type: "unauthenticated" });
          }
        }
        throw e; // IMPORTANT: do not swallow; bubble up to the Login page catch
      }
    },
    [publicFetch]
  );
}

//previous
// export function useUserLogin() {
//   const publicFetch = usePublicFetch();

//   return useCallback(async ({ email, password }) => {
//     try {
//       // Will either return { ok:true, status, data } or throw ResponseError
//       const { status, data } = await publicFetch(`${API}/v1/auth/login`, {
//         method: "POST",
//         credentials: "include",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ email, password }),
//       });

//       if (!data?.success) {
//         authBus.emit({ type: "unauthenticated" });
//       }

//       saveCsrfToken(data);
//       authBus.emit({ type: "authenticated" });
//       return { status, data };
//     } catch (err) {

//     }
//   }, []);
// }

/*
export function useUserLogin() {
  // const { setIsLoggedIn } = useContext(AuthContext);

  const login = // useCallback(
    async ({ email, password }) => {
      try {
        const response = await fetch(
          "https://pwa-server.test/api/v1/auth/login",
          {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email, password }),
          }
        );

        if (!response.ok) {
          authBus.emit({ type: "unauthenticated" });
          throw response;
        }

        const data = await response.json().catch(() => null);
        saveCsrfToken(data);
        authBus.emit({ type: "authenticated" });
        console.log(data);
        return data;
      } catch (error) {
        if (error instanceof Response) {
          // Handle HTTP error responses
          const errorData = await error.json(); // Or .text() if not JSON
          throw new Error(
            errorData?.message ||
              `Login failed: ${error.status} ${error.statusText}`
          );
        } else {
          // Handle network errors or other unexpected errors
          throw new Error(`An unexpected error occurred: ${error.message}`);
        }

        // if (!response.ok) {
        //   authBus.emit({ type: "unauthenticated" });
        //   throw response; //new Error(data?.message || `Login failed`); // (${response.status})`);
        // } else {
        //   saveCsrfToken(data);
        //   authBus.emit({ type: "authenticated" });
        // }

        // return data;
      }
    };
  return login;
}
*/

export function useUserLogout({ routeErrors = true } = {}) {
  const fetchWithAuth = useAuthorizedFetch();
  const { showErrorPage } = useRouteError();
  const location = useLocation();

  const logout = useCallback(async () => {
    try {
      const { status, data } = await fetchWithAuth(`${API}/logout`, {
        method: "POST",
        retryOnFail: true,
      });

      if (data?.success === false) {
        authBus.emit({ type: "authenticated" }); // problem logging out
        const err = Object.assign(new Error("Logout failed"), {
          status,
          data,
        });
        throw err;
      }

      // Success
      authBus.emit({ type: "unauthenticated" });
      deleteCsrfToken();

      return { status, data };
    } catch (err) {
      const currentPath = location.pathname;

      if (routeErrors) {
        console.log("routeErrors = true");
        showErrorPage({
          title: "An Error occurred during logout.",
          message: err?.message ?? "We couldn't log you out.",
          status: err?.status ?? 400,
          detail: err?.data ?? err,
          onRetry: "/logout",
          backTo: "",
          // onRetry: () =>
          //   fetchWithAuth(`${API}/logout`, {
          //     method: "POST",
          //     retryOnAuth: false,
          //   }),
          // backTo: -2, //currentPath, // optional: where to return
        });
      } else {
        // Let caller do inline UI handling
        throw err;
      }
    }
  }, []);

  return logout;
}
/*
export function useUserLogout({ routeErrors = true } = {}) {
  // const navigate = useNavigate();
  // const { setIsLoggedIn } = useContext(AuthContext);

  // const fetchWithAuth = useAuthorizedFetch({
  //   maxRetries: 2,
  //   timeoutMs: 20000,
  // });
  const fetchWithAuth = useAuthorizedFetch();
  const { showErrorPage } = useRouteError();

  const logout = useCallback(
    async () => {
      //} ({ redirectTo = null } = {}) => {
      try {
        const { status, data } = await fetchWithAuth(`${API}/logout`, {
          method: "POST",
          retryOnFail: true,
        });

        // if (!data?.success) {
        //   const err = Object.assign(new Error("Logout failed"), {
        //     status,
        //     data,
        //   });
        //   throw err;
        // }

        // Some APIs might return 200 with { success:false } — treat as a logical failure.
        if (data?.success === false) {
          authBus.emit({ type: "authenticated" }); // problem logging out
          const err = Object.assign(new Error("Logout failed"), {
            status,
            data,
          });
          throw err;
          // throw new ResponseError(data?.message || "Logout failed", {
          //   status,
          //   data,
          // });
        }
        // Success path

        authBus.emit({ type: "unauthenticated" });
        deleteCsrfToken();

        return { status, data };
      } catch (err) {
        console.log("showErrorPage");
        if (routeErrors) {
          console.log("routeErrors = true");
          showErrorPage({
            title: "An Error occurred during logout. Try Again.",
            message: err?.message ?? "We couldn't log you out.",
            status: err?.status ?? 400,
            detail: err?.data ?? err, // raw server JSON or error object
            // onRetry: () => alert("retrying"),
            onRetry: () =>
              fetchWithAuth(`${API}/v1/auth/logout`, {
                method: "POST",
                retryOnAuth: false,
              }),
            backTo: "/", // optional: where to return
          });
        } else {
          // Let caller do inline UI handling
          throw err;
        }
        // throw e; // IMPORTANT: do not swallow; bubble up to the Logout page catch
        // throw new Error(err?.message || "Network error while logging out.");
      }

      // if (!response.ok) {
      //   const msg = typeof data === "string" ? data : data?.message;
      //   throw new Error(msg || `Logout failed (${response.status})`);
      // }

      // Clear client auth state
      // setIsLoggedIn(false);
      // authBus.emit({ type: "unauthenticated" });
      // deleteCsrfToken();

      // if (redirectTo) {
      //   navigate(redirectTo, { replace: true });
      // }

      // return { success: true, data };
    },
    [fetchWithAuth] //[fetchWithAuth, navigate]
  );

  // Prefer returning an object; change to `return logout` if you like function-only.
  return { logout };
}
*/

/**
 * User Logout Hook: returns a logout function that updates AuthContext on success.
 *
 * @returns {string} json {"success": true, "message": "Login Successful.", "data": []]}
 */
// export function useUserLogout() {
//   const { setIsLoggedIn } = useContext(AuthContext);
//   // alert("hello");

//   const fetchWithAuth = useFetchWithAuth({
// maxRetries: 0, //On error retry the api call
// timeoutMs: 20000,
//   }); //set defaults.

//   async function load() {
//     const response = await fetchWithAuth(
//       "https://pwa-server.test/api/v1/auth/logout",
//       {
//         method: "POST",
//         retryOnFail: false, //do not try refreshing the token on 401/403 errors
//       }
//     );

//     const data = await response.json().catch(() => null);

//     if (!response.ok) {
//       // handle 401/403/other here
//       throw new Error(data?.message || `Logout failed (${response.status})`);
//     }
//     // console.log(data);
//     // return data;

//     // const logout = useCallback(async () => {
//     //   const response = await fetchWithAuth(
//     //     "https://pwa-server.test/api/v1/auth/logout",
//     //     {
//     //       method: "POST",
//     //       maxRetries: 2, //on error retry the api call
//     //       retryOnFail: false, //do not try refreshing the token on 401/403 errors
//     //     }
//     //   );

//     //   const data = await response.json().catch(() => null);

//     // if (!response.ok) {
//     //   throw new Error(data?.message || `Logout failed (${response.status})`);
//     // }

//     // Don’t toggle; set explicitly true on successful login.
//     setIsLoggedIn(false);

//     return data;
//   }

// [setIsLoggedIn]
// );

// return;
// }

//not a hook, useContext wont work
// export async function userLogin({ email, password }) {
//   const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);

//   const response = await fetch("https://pwa-server.test/api/v1/auth/login", {
//     method: "POST",
//     credentials: "include",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ email, password }),
//   });

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.message || "Login failed");
//   }

//   setIsLoggedIn(!isLoggedIn);
//   return response.json();
// }

/**
 * User Logout
 *
 * @returns {string} json {"success": true, "message": "Login Successful.", "data": []]}
 */
// export async function userLogout() {
//   const response = await fetchWithAuth(
//     "https://pwa-server.test/api/v1/auth/logout",
//     {
//       method: "POST",
//       maxRetries: 2, //on error retry the api call
//       retryOnFail: false, //do not try refreshing the token on 401/403 errors
//     }
//   );
//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.message || "Logout failed");
//   }

//   return response.json();
// }
